import React from 'react'

import { FORMULA_OPERAND_MIN_WIDTH } from 'components_new/molecules/FormulaBlock'
import { OptionProps } from 'components_new/molecules/OptionsMenu'
import OptionsMenuButton from 'components_new/molecules/OptionsMenuButton'

export interface FormulaAddButtonProps {
  /** What the operand can be, as the menu offers it. */
  options: OptionProps[]
  tooltip?: string
}

/**
 * An operand nobody has filled in yet: a dashed field that opens the menu of
 * what it could be.
 */
const FormulaAddButton = (props: FormulaAddButtonProps) => {
  const { options, tooltip } = props

  return (
    <OptionsMenuButton
      options={options}
      sx={{ minWidth: FORMULA_OPERAND_MIN_WIDTH, width: '100%' }}
      tooltip={tooltip}
      variant="buttonField"
    />
  )
}

export default FormulaAddButton
